export const estadosBrasileiros = () => {
    return [
        {id:1,value: "Acre", key: "AC"},
        {id:2,value: "Alagoas", key: "AL"},
        {id:3,value: "Amapá", key: "AP"},
        {id:4,value: "Amazonas", key: "AM"},
        {id:5,value: "Bahia", key: "BA"},
        {id:6,value: "Ceará", key: "CE"},
        {id:7,value: "Distrito Federal", key: "DF"},
        {id:8,value: "Espírito Santo", key: "ES"},
        {id:9,value: "Goiás", key: "GO"},
        {id:10,value: "Maranhão", key: "MA"},
        {id:11,value: "Mato Grosso", key: "MT"},
        {id:12,value: "Mato Grosso do Sul", key: "MS"},
        {id:13,value: "Minas Gerais", key: "MG"},
        {id:14,value: "Pará", key: "PA"},
        {id:15,value: "Paraíba", key: "PB"},
        {id:16,value: "Paraná", key: "PR"},
        {id:17,value: "Pernambuco", key: "PE"},
        {id:18,value: "Piauí", key: "PI"},
        {id:19,value: "Rio de Janeiro", key: "RJ"},
        {id:20,value: "Rio Grande do Norte", key: "RN"},
        {id:21,value: "Rio Grande do Sul", key: "RS"},
        {id:22,value: "Rondônia", key: "RO"},
        {id:23,value: "Roraima", key: "RR"},
        {id:24,value: "Santa Catarina", key: "SC"},
        {id:25,value: "São Paulo", key: "SP"},
        {id:26,value: "Sergipe", key: "SE"},
        {id:27,value: "Tocantins", key: "TO"}
    ]
}